import CountryPageRenderer from '../components/CountryPageRenderer';
import sriLankaData from '../data/country-pages/sri-lanka';

export default function SriLankaCountryPage() {
  return <CountryPageRenderer data={sriLankaData} />;
}
